<template>
  <div class="pickdate">
    <form class="form-inline">
      <dropdown v-model="show" class="form-group">
        <label>Select a pick date:</label>
        <div class="input-group">
          <input
            readonly
            type="text"
            :value="value"
            @click="show = !show"
            icon-control-left="glyphicon glyphicon-menu-left"
            icon-control-right="glyphicon glyphicon-menu-right"
            class="form-control date__input">
          <div class="input-group-btn">
            <btn class="dropdown-toggle"><i class="glyphicon glyphicon-calendar"></i></btn>
          </div>
        </div>
        <template slot="dropdown">
          <li>
            <date-picker :value="value" @input="updateValue" format="yyyy-MM-dd" :clear-btn="false"/>
          </li>
        </template>
      </dropdown>
    </form>
  </div>
</template>

<script>
export default {
  name: 'PickDate',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style scoped>
.date__input:hover {
  cursor: pointer;
}
.pickdate {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/PickDate.vue